import { TaskCard, TaskCardProps } from 'components/TaskCard/TaskCard';
import { ReactComponent as ArticleIcon } from 'assets/icons/ArticleIcon.svg';
import React from 'react';
import { SvgIcon } from 'components/SvgIcon/SvgIcon';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

interface ArticleTaskCardProps extends Omit<TaskCardProps, 'taskTypeLabel' | 'icon'> {
  articleName: string;
}

export const ArticleTaskCard = ({
  articleName,
  careProgramName,
  isCompleted,
  onClick,
}: ArticleTaskCardProps) => {
  const { translation } = useTranslationContext();

  return (
    <TaskCard
      icon={<SvgIcon component={ArticleIcon} />}
      taskTypeLabel={translation('checklist_task_type_article')}
      taskName={articleName}
      careProgramName={careProgramName}
      isCompleted={isCompleted}
      onClick={onClick}
    />
  );
};
